import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllBlogs, getCategories } from '../data/blogData';
import AdSenseUnit from '../components/AdSenseUnit';
import ScrollToTop from '../components/ScrollToTop';
import '../styles/BlogsPage.css';

export default function BlogsPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', ...getCategories()];
  const allBlogs = getAllBlogs();
  console.log('All blogs:', allBlogs.length, allBlogs.map(b => b.slug));
  const filtered = activeCategory === 'All' ? allBlogs : allBlogs.filter(b => b.category === activeCategory);

  return (
    <div className="blogs-page">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg blogs-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/sidebar-logo.png" alt="MeetingPoint Logo" loading="lazy" />
          </Link>
          <div className="d-flex align-items-center gap-3">
            <Link to="/" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-arrow-left me-2"></i>Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="blogs-hero">
        <div className="container text-center">
          <span className="blogs-chip">INSIGHTS & GUIDES</span>
          <h1 className="blogs-title">MeetingPoint <span className="gradient-text">Blog</span></h1>
          <p className="blogs-subtitle">Explore how peer-to-peer communication is reshaping privacy, collaboration, and the way we connect online.</p>
        </div>
      </header>

      {/* Category Filter */}
      <div className="container">
        <div className="category-filter">
          {categories.map(cat => (
            <button
              key={cat}
              className={`category-pill${activeCategory === cat ? ' active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* AdSense Unit - Before Blog Grid */}
      <div className="container">
        <AdSenseUnit adSlot="9661048079" adFormat="auto" />
      </div>

      {/* Blog Grid */}
      <section className="container blogs-grid-section">
        <div className="blogs-grid">
          {filtered.map(post => (
            <Link to={`/blogs/${post.slug}`} key={post.slug} className="blog-card-link">
              <article className="blog-card">
                <div className="blog-card-icon">
                  <i className={`fas ${post.icon}`}></i>
                </div>
                <span className="blog-card-category">{post.category}</span>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-meta">
                  <span><i className="far fa-calendar-alt me-1"></i>{new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                  <span><i className="far fa-clock me-1"></i>{post.readTime}</span>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="blogs-footer">
        <div className="container text-center">
          <p className="mb-1">&copy; {new Date().getFullYear()} MeetingPoint. All rights reserved.</p>
          <div className="d-flex justify-content-center gap-3 mt-2 flex-wrap">
            <Link to="/" className="text-muted">Home</Link>
            <Link to="/about" className="text-muted">About</Link>
            <Link to="/blogs" className="text-muted">Blog</Link>
            <Link to="/faq" className="text-muted">FAQ</Link>
            <Link to="/contact" className="text-muted">Contact</Link>
            <Link to="/privacy" className="text-muted">Privacy Policy</Link>
            <Link to="/terms" className="text-muted">Terms</Link>
            <Link to="/disclaimer" className="text-muted">Disclaimer</Link>
          </div>
        </div>
      </footer>
      <ScrollToTop />
    </div>
  );
}
